export default {
    label: 'labelledElement-label',
    childrenWrapper: 'labelledElement-children',
};
//# sourceMappingURL=dataHooks.js.map